import axios from 'axios'
import Settings from './settings.js'
import { updateQueryParams, getInternalAuthToken } from './my_utils.js'

class Caller {
  /**
   * Create a new Caller instance.
   */
  constructor () {
    this.axios = axios
    this.settings = new Settings()
  }

  getHeaders (headerType) {
    // Default headers per request
    const defaultHeader = {
      accept: 'shared api; version=1',
      Authorization: getInternalAuthToken(),
      ADMINREQUEST: getInternalAuthToken()
    }
    // Modify header based on its type
    switch (headerType) {
      case 'applicant_headers':
        return { ...defaultHeader, accept: 'applicant api; version=1' }
      case 'company_headers':
        return { ...defaultHeader, accept: 'company api; version=1' }
      case 'admin_headers':
        return { ...defaultHeader, accept: 'admin api; version=1' }
      case 'public_headers':
        return { ...defaultHeader, accept: 'public api; version=1' }
      default:
        return { ...defaultHeader }
    }
  }

  request (requestType, url, headers, data, controller) {
    const signal = controller ? controller.signal : null
    data = typeof data !== 'undefined' ? data : {}
    headers = typeof headers === 'string' ? this.getHeaders(headers) : headers
    var base_url = data.is_files
      ? this.settings.get({ path: 'files_url' })
      : this.settings.get({ path: 'base_api_url' })
    let request_url = base_url + url
    request_url = requestType.toLowerCase() == 'get' ? updateQueryParams(request_url, data) : request_url
    return new Promise((resolve, reject) => {
      axios
        .request({
          method: requestType,
          responseType: data.responseType,
          url: request_url,
          headers,
          data: data,
          signal: signal
        })
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          reject(error)
        })
    })
  }

  sendToLogin () {
    console.log('sending')
  }
}

export default Caller
